module.exports = __webpack_public_path__ + "icon-check-blue-693f92b8239a25497ba50c41aa178fce.svg";